import React, { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import Button from 'components/Button';
import classnames from 'classnames';

import { useScript } from 'hooks/useScript';
import HeaderLogo from 'components/HeaderLogo';

import SignupForm from './components/SignupForm';
import styles from './Signup.module.scss';
import { scrollToElem } from './smooth-scrolling-polyfill';

export const pageId = 'signupPage';
export const formSectionId = 'signupFormSection';

export default function Signup() {
  const [formPositionY, setFormPositionY] = useState(null);
  const [windowHeight, setWindowHeight] = useState(null);
  const [displayPrompt, setDisplayPrompt] = useState(false);
  const [marketoScriptReady, setMarketoReady] = useState(false);
  const marketoScriptStatus = useScript(
    '//go.everbridge.com/js/forms2/js/forms2.min.js',
  );

  useEffect(() => {
    const handleResizeAndScroll = throttle(() => {
      setFormPositionY(
        document.getElementById(formSectionId).getBoundingClientRect().top,
      );
      setWindowHeight(window.innerHeight);
    }, 50);
    handleResizeAndScroll();

    window.addEventListener('resize', handleResizeAndScroll);
    window.addEventListener('scroll', handleResizeAndScroll);
    return () => {
      window.removeEventListener('resize', handleResizeAndScroll);
      window.removeEventListener('scroll', handleResizeAndScroll);
    };
  }, []);

  useEffect(() => {
    const pageHeight = document.getElementById(pageId).offsetHeight;
    const reachBottomOfPage = windowHeight + window.pageYOffset >= pageHeight;
    setDisplayPrompt(formPositionY > 1 && !reachBottomOfPage);
  }, [formPositionY, windowHeight]);

  useEffect(() => {
    if (marketoScriptStatus === 'ready' && window.MktoForms2) {
      window.MktoForms2.loadForm(
        '//go.everbridge.com',
        '004-QSK-624',
        3783,
        (form) => {
          // override onSuccess handler to prevent url redirecting set on Marketo
          form.onSuccess(() => false);
        },
      );
      setMarketoReady(true);
    }
  }, [marketoScriptStatus]);

  return (
    <div className={styles.signupPage} id={pageId}>
      <div className={styles.logoWrap}>
        <HeaderLogo />
      </div>
      <div className={classnames(styles.column, styles.introSection)}>
        <div className={styles.content}>
          <div className={styles.greenBar} />
          <h1 className={styles.h1} data-testid="signUpHeader">
            2.7 million global users count on xMatters
          </h1>
          <h2 className={styles.h3} data-testid="signUpSubHeader">
            Ensure service reliability. Sign up today.
          </h2>
          <img
            className={styles.image}
            src="/assets/images/signup-intro.svg"
            alt="signup intro"
          />
        </div>
      </div>
      <div
        className={classnames(styles.column, styles.formSection)}
        id={formSectionId}
      >
        <SignupForm marketoScriptReady={marketoScriptReady} />
        <form id="mktoForm_3783" style={{ display: 'none' }}></form>
      </div>
      {displayPrompt && (
        <div className={styles.prompt}>
          <Button
            className={styles.promptButton}
            onClick={() => scrollToElem(`#${formSectionId}`)}
            data-testid="tryItFree_btn"
          >
            Try it free
          </Button>
        </div>
      )}
    </div>
  );
}
